module.exports = __webpack_public_path__ + "static/media/IMG_5086-min.d74f3419.jpg";